require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-reason-react-native-scripts.json") })
        }
      }, "path---package-reason-react-native-scripts");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-reason-react-native-scripts!./.cache/json/package-reason-react-native-scripts.json
// module id = 900
// module chunks = 231608221292675